import React from "react";

import { Tooltip } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

import type { StepsProps } from "../create-project-schema";

const textColors = {
  pending: "text-type-light",
  done: "text-type-success",
  in_progress: "text-labels-primary",
};

const bgColors = {
  pending: "bg-neutrals-90",
  done: "bg-type-success",
  in_progress: "bg-neutrals-60",
};

const StepItem = ({ status, title }: { status: "pending" | "done" | "in_progress"; title: string }) => {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = React.useState<number | null>(null);

  React.useEffect(() => {
    if (ref.current?.offsetWidth) {
      setWidth(ref.current.offsetWidth);
    }
    const eventLink = () => {
      if (ref.current?.offsetWidth) {
        setWidth(ref.current.offsetWidth);
      }
    };
    window.addEventListener("resize", eventLink);

    return () => window.removeEventListener("resize", eventLink);
  }, []);

  return (
    <div ref={ref} className={cn("flex w-full min-w-0 cursor-default flex-col items-center justify-center gap-1", textColors[status])}>
      <div style={{ width: width ?? undefined }}>
        <Tooltip description={title} arrowSide="bottom">
          <div className="truncate text-center text-sm font-medium">{title}</div>
        </Tooltip>
      </div>
      <div className={cn("h-1 w-full rounded-[2px]", bgColors[status])} />
    </div>
  );
};

export const StepStatusBar = ({ steps }: { steps: StepsProps }) => {
  return (
    <div className="mb-8 flex w-full gap-2">
      {Object.values(steps).map((item, index) => {
        return <StepItem title={item.title} status={item.status} key={index} />;
      })}
    </div>
  );
};
